module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAXVBMVEUAAADKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysr521A1AAAAHnRSTlMA+KWSaEcE+4pd8ufJsJh8LBcJAlnXw1A3JyHZODZXJbU1AAAAyklEQVQ4y72S2w6DIBBEBbWiIKJ4b7v//5kNSm0cxaYvPS9q5sSww0a/Ir7kAw2X+a2j7nYlJESUXOSNJCLZhIWKHFUwr4tFKOqQENNKfB7bR+YFNlqczuRxX9CHoo9z854314rRGUzp3AnpFh+VdP1FFsizduvvnAQKQqpdAwC2YTkh3O6bKCEv8dZTENLjJuAEgABBoMDxjCgoEBQK0gd3/5S4jX64ZzT6gWEzJ3c33Czvhrvbm7AGpufta9YMi2hFvd9f0UZ/4wWhZSnu6MuRiAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/core-link-icon.png
// module id = 3+r/
// module chunks = 0